import { ILocale } from "../../@redux/actions/locale";
import { faIR, enUS } from  "@mui/material/locale";
import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import EN from "@commons/locales/En.json";
import FA from "@commons/locales/Fa.json";

const Locales: ILocale[] = [
  {
    key: "en-US",
    language: "English",
    short: "En",
    direction: "ltr",
    muiLocale: enUS,
  },
  {
    key: "fa-IR",
    language: "Persian",
    short: "Fa",
    direction: "rtl",
    muiLocale: faIR,
  },
];

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: EN,
      },
      fa: {
        translation: FA,
      },
    },
    fallbackLng: "en",
    keySeparator: false,
  });

export { Locales, i18n };
